import React from 'react';
import {Link} from 'gatsby';
import {useCategories} from '../../query/useCategories';

import styles from './styles.module.css';

const Categories = () => {
  const {categories} = useCategories();
  return (
    <div className={styles.categories}>
      <div>Catégories:</div>
      <ul>
        {categories.edges.map(({node}) => {
          const {productsCategorie} = node;
          // display only if has product
          if (productsCategorie === null || productsCategorie.length === 0) {
            return null;
          }
          return (
            <li key={node.fields.slug} id={node.fields.slug}>
              <Link to={node.fields.slug}>
                {node.frontmatter.icon && (
                  <img alt="" src={node.frontmatter.icon.publicURL} />
                )}
                <span>{node.frontmatter.title}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Categories;
